import React, { FC, ReactElement, useContext } from 'react';
import { Route, Switch } from 'react-router-dom';

import { Users } from '../Pages/Users';
import { OrgStructure } from '../Pages/OrgStructure';
import { UserProfile } from '../Pages/UserProfile';
import { Context } from '../services/context';
import { ExceptionWords } from '../Pages/ExceptionWords';

export const Routes: FC = (): ReactElement => {
  const { userData } = useContext(Context);
  return (
    <>
      <Switch>
        <Route path="/structure" exact>
          <OrgStructure />
        </Route>
        {userData?.role === 'Администратор' ? (
          <Route path="/users" exact>
            <Users />
          </Route>
        ) : null}

        <Route path="/user/:id" exact>
          <UserProfile />
        </Route>

        <Route path="/exception-words" exact>
          <ExceptionWords />
        </Route>

        {/* {userData?.role === 'Администратор' ? (
          <Route path="/logs" exact>
            <Logs />
          </Route>
        ) : null}

        <Route path="/configuration" exact>
          <Configuration />
        </Route>

        <Route path="/thanks">
          <Thanks />
        </Route> */}
      </Switch>
    </>
  );
};
